/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  DeleteWithdrawalSecretsMutationRequest,
  DeleteWithdrawalSecretsMutationResponse,
  DeleteWithdrawalSecrets400,
  DeleteWithdrawalSecrets403,
} from '../entities/DeleteWithdrawalSecrets'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getDeleteWithdrawalSecretsUrl() {
  return `/withdrawal-secrets` as const
}

/**
 * @description Удаление api-ключа вывода средств для таксопарка
 * @summary Удаление api-ключа вывода средств для таксопарка
 * {@link /withdrawal-secrets}
 */
export async function deleteWithdrawalSecrets(
  data: DeleteWithdrawalSecretsMutationRequest,
  config: Partial<RequestConfig<DeleteWithdrawalSecretsMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    DeleteWithdrawalSecretsMutationResponse,
    ResponseErrorConfig<DeleteWithdrawalSecrets400 | DeleteWithdrawalSecrets403>,
    DeleteWithdrawalSecretsMutationRequest
  >({ method: 'DELETE', url: getDeleteWithdrawalSecretsUrl().toString(), data, ...requestConfig })
  return res.data
}